import { useRouter } from "expo-router";
import { Pressable, StyleSheet, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { AppText } from "~/components/ui";
import { spacing, useThemedStyles, type ThemeColors } from "~/styles/theme";

/**
 * Mobile only, shown on every screen while the person has no account: their
 * lists live on this device and are never uploaded.
 */
export function LocalDataBanner() {
  const styles = useThemedStyles(makeStyles);
  const router = useRouter();
  const insets = useSafeAreaInsets();
  return (
    <View style={[styles.banner, { paddingTop: insets.top + spacing.s }]}>
      <AppText size="xs">
        Your gear is only saved on this device. Create a free account to back it
        up and sync it across devices.
      </AppText>
      <Pressable
        accessibilityRole="link"
        accessibilityLabel="Create a free account"
        onPress={() => router.push("/register")}
      >
        <AppText size="xs" weight="semibold">
          Create free account →
        </AppText>
      </Pressable>
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    banner: {
      gap: spacing.xs,
      paddingHorizontal: spacing.l,
      paddingBottom: spacing.s,
      backgroundColor: colors.dangerSurface,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
  });
